import CASMailbox from 'owa-service/lib/contract/CASMailbox';
import GetCASMailboxOptions from 'owa-service/lib/contract/GetCASMailboxOptions';
import GetCASMailboxRequest from 'owa-service/lib/contract/GetCASMailboxRequest';
import getCASMailbox2Operation from 'owa-service/lib/operation/getCASMailbox2Operation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

function createRequestBody(): GetCASMailboxRequest {
    let options: GetCASMailboxOptions = {};

    let request: GetCASMailboxRequest = {
        Header: getJsonRequestHeader(),
        Options: options,
    };

    return request;
}

export default function getCASMailboxOptions(): Promise<CASMailbox> {
    return getCASMailbox2Operation(createRequestBody()).then(response => {
        return response.Options;
    });
}
